import { useState, useEffect } from 'react';
import { Notification } from '@mantine/core';
import { IconWifi, IconWifiOff } from '@tabler/icons-react';

/**
 * Offline Indicator Component
 *
 * Shows a notification when the user goes offline.
 * Automatically hides when connection is restored.
 */
export function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOffline, setShowOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOffline(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showOffline) return null;

  return (
    <Notification
      icon={<IconWifiOff size={18} />}
      color="yellow"
      title="You're offline"
      onClose={() => setShowOffline(false)}
      style={{
        position: 'fixed',
        top: '70px',
        left: '16px',
        right: '16px',
        zIndex: 1000,
      }}
    >
      Some features may be limited. Cached content is still available.
    </Notification>
  );
}
